import React from "react";
import DepositNew from "../../Component/WalletPage/DepositNew";

function DepositPage() {
    return (
        <div className="container-xxl">
            <DepositNew />
        </div>
    );
}

export default DepositPage;
